export enum UploadTypesEnum {
  CROSSREFERENCE = 'CROSSREFERENCE',
  SPEND = 'SPEND',
  AGREEMENT_PRODUCT_PRICE = 'AGREEMENT_PRODUCT_PRICE',
  AGREEMENT_EXCLUSIONS = 'AGREEMENT_EXCLUSIONS',
  OFFER_PRICING_FILE = 'OFFER_PRICING_FILE',
}
